import { createSkeletonEvent } from 'api/event'
import { ForwardButton } from 'components/button/button.styled'
import { LoadingContainer } from 'components/loadingContainer'
import { ModeSelection } from 'components/modeSelection'
import { ShowForm, ShowListWizard } from 'features/admin/Show'
import { useShowsAdmin } from 'hooks/admin/useShows'
import React, { useEffect, useState } from 'react'

import { ButtonContainer, FormContent } from '../eventWizard.style'

interface FirstStepProps {
    onNext: (data: Record<string, any>) => void
    eventData: Record<string, any>
    partnerId?: string
    generatedEventId?: string
}

export const FirstStep: React.FC<FirstStepProps> = ({ onNext, eventData, partnerId, generatedEventId }) => {
    const [mode, setMode] = useState<'select' | 'create'>('select')
    const [showId, setShowId] = useState<string | null>(eventData.show_id || null)
    const { showsData, showsLoading, showsError } = useShowsAdmin(partnerId)
    const [isNextDisabled, setIsNextDisabled] = useState(!showId)
    const [isCreatingEvent, setIsCreatingEvent] = useState(false)

    useEffect(() => {
        if (showId) setIsNextDisabled(false)
    }, [showId])

    const handleNext = async () => {
        // If this is a new event (not editing), create a skeleton event first
        if (generatedEventId && !eventData.event_id) {
            setIsCreatingEvent(true)
            try {
                await createSkeletonEvent(generatedEventId, showId!, partnerId)
                onNext({ show_id: showId, event_id: generatedEventId })
            } catch (error) {
                console.error('Error creating skeleton event:', error)
                alert('Hiba történt az esemény létrehozása során')
            } finally {
                setIsCreatingEvent(false)
            }
        } else {
            onNext({ show_id: showId })
        }
    }

    const handleModeChange = (newMode: 'select' | 'create') => {
        setMode(newMode)
        setShowId(null)
        setIsNextDisabled(true)
    }

    return (
        <>
            <ButtonContainer hasbackbutton={false}>
                <ForwardButton
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    label="Következő"
                    onClick={handleNext}
                    disabled={isNextDisabled || isCreatingEvent}
                    type="submit"
                />
            </ButtonContainer>
            <ModeSelection
                options={[
                    { value: 'select', label: 'Létező műsor kiválasztása az esemény számára' },
                    { value: 'create', label: 'Új műsor felvétele az esemény számára' },
                ]}
                selectedValue={mode}
                buttonClassName="my-button"
                selectedButtonClassName="selected"
                onChange={handleModeChange}
            />
            <FormContent>
                <LoadingContainer isLoading={showsLoading} error={showsError}>
                    {mode === 'select' && showsData && (
                        <ShowListWizard data={showsData} setIdOnClick={setShowId} initialSelectedId={showId} />
                    )}
                    {mode === 'create' && <ShowForm onSuccess={() => setMode('select')} />}
                </LoadingContainer>
            </FormContent>
        </>
    )
}
